class Complect {

  constructor(elem) {
    this.complect = elem;
    this.size = this.complect.find('[data-complect-size]');
    this.sizeItem = this.complect.find('[data-complect-size-item]');
    this.choose = this.complect.find('[data-complect-choose]');
    this.total = this.complect.find('[data-complect-total]');
    this.price = this.complect.find('[data-complect-price]');
    this.btn = this.complect.find('[data-complect-button]');
	}

  initialize() {
    const that = this;
    let size = this.size;
    let price = this.price;
    let total = this.total;

    // открытие всплывающего окна с размерами
    this.size.on('click', function(e) {
      let el = $(this);
      let detail = el.next('[data-complect-size-detail]');

      size.not(el).removeClass('active');
      size.not(el).next('[data-complect-size-detail]').slideUp('fast')

      el.toggleClass('active')
      detail.slideToggle('fast')

      e.preventDefault();
    });

    // выбор размера в выпадающем окне
    this.sizeItem.on('click', function(e) {
      let el = $(this);
      let text = el.text();
      let detail = el.closest('[data-complect-size-detail]');
      let size = detail.prev();

      size.children().text(text);

      detail.slideToggle('fast')
      size.toggleClass('active');

      detail.find('[data-complect-size-item]').removeClass('active')
      el.addClass('active')

      e.preventDefault();
    });

    // выбор товара из комплекта
    this.choose.on('change', function(e) {
      let el = $(this);
      let parent = el.closest('[data-complect-item]');
      let sizeBtn = parent.find('[data-complect-size]');
      let priceTotal = 0;

      parent.toggleClass('disabled');

      sizeBtn['0'].toggleAttribute('disabled');

      price.each(function() {
        let el = $(this);
        let priceParent = el.closest('[data-complect-item]');
        let text = el.text().replace('₽', '');

        text = parseInt(text.replace(' ', ''));

        if (!priceParent.hasClass('disabled')) {
          priceTotal+= text;
        }
      });

      total.text(priceTotal.toLocaleString('ru') + ' ₽');

      let isChecked = false;
      that.choose.each((checkbox) => {
        if ($(that.choose[checkbox]).is(':checked')) {
          isChecked = true;
          that.btn.attr('disabled', false);
        } else if (!isChecked) {
          that.btn.attr('disabled', true);
        }
      });

      e.preventDefault();
    });
	}
}

export {Complect};

$(function () {
  window.Complect = Complect;
});

$(window).on('load', () => {
  let complects = [];

  if ($('[data-complect]').length > 0) {
		$('[data-complect]').each(function(i) {
			complects[i] = new Complect($(this));
			complects[i].initialize();
		});
	}
});
